(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["empreinte-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ee-campaign-timer')) {
  customElements.define('ee-campaign-timer', class extends HTMLElement {
    connectedCallback() {
      this.endTime = Date.parse(this.dataset.end);
      const update = () => {
        const remaining = Math.floor((this.endTime - Date.now()) / 1000);
        if (!Number.isFinite(remaining) || remaining <= 0) {
          this.hidden = true;
          clearInterval(this.interval);
          return;
        }
        const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
        for (const [unit,value] of Object.entries(values)) {
          this.querySelector('[data-unit="'+unit+'"]').textContent = String(value).padStart(2,'0');
        }
        this.hidden = false;
      };
      update();
      if (!this.hidden) this.interval = setInterval(update,1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
